import * as firebase from 'firebase'
import { firebaseConfig } from './firebaseConfig'
console.log('app',firebase.apps)
!firebase.apps.length && firebase.initializeApp(firebaseConfig)

export { firebase }


// WEBPACK FOOTER //
// ./src/config/firebase.js